import { ErrorBoundary, createConfig, createFlowContext } from '@betterment/shared-components';
import { Outlet, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { IdempotencyProviderWithFeatureRegistry } from '../../../RetailApp/graphql/idempotency/IdempotencyProviderWithFeatureRegistry';
import { nameAndImage } from '../sharedSchemas';

export const target = Yup.object({
  amount: Yup.string().optional(),
  month: Yup.string()
    .required()
    .test('target-date-in-future', "Target date must be after today's date.", function checkDate(month) {
      const { year } = this.parent as { year: string };
      const today = new Date();
      const targetDate = new Date(`${month}, ${year}`);
      return targetDate > today;
    }),
  year: Yup.string().required(),
});

export const MAJOR_PURCHASE_FLOW_CONFIG = createConfig({
  nameAndImage: {
    schema: nameAndImage,
    dependencies: Yup.object({}),
  },
  target: {
    schema: target,
    dependencies: Yup.object({
      nameAndImage,
    }),
  },
});

export const { FlowProvider, useStep: useMajorPurchaseStep } = createFlowContext(MAJOR_PURCHASE_FLOW_CONFIG);

export const MajorPurchaseFlow = () => {
  const { flowId } = useParams<{ flowId: string }>();

  return (
    <ErrorBoundary fallbackType="full">
      <FlowProvider flowId={flowId}>
        <IdempotencyProviderWithFeatureRegistry featureName="completeDraftPurposeFlow">
          <Outlet />
        </IdempotencyProviderWithFeatureRegistry>
      </FlowProvider>
    </ErrorBoundary>
  );
};
